import axios from "axios"
import { env } from "../constants"

/* Reference data — cities and categories. Loaded once on app start. */

export const cities = () => {
    const uri = `${env.startpoint}cities`
    return axios.get(uri).then(response => response).catch(error => error.response)
}

export const categories = () => {
    const uri = `${env.startpoint}categories`
    return axios.get(uri).then(response => response).catch(error => error.response)
}

export const suggest = (q, city) => {
    const uri = `${env.startpoint}search/suggest`
    return axios.get(uri, { params: { q, city } }).then(response => response).catch(error => error.response)
}
